<template>
    <span>
        <div v-if="statusText != '' && statusColor != '' && isHexColor(statusColor)" :style="statusStyle(statusColor)">
        {{ statusText }}
        </div>
        <a-tag v-else-if="statusText != '' && statusColor != ''" :color="statusColor">
        {{ statusText }}
        </a-tag>
    </span>
</template>

<script>

export default {
  name: 'StatusTag',
  props: {
    statusText: {
        type: String,
        default: ''
    },
    statusColor: {
        type: String,
        default: ''
    },
  },
  methods: {
    isHexColor(color) {
        return /^#[0-9A-Fa-f]{6}$/.test(color);
    },
    statusStyle(color) {
        const opacityBackground = this.hexToRgba(color, 0.3);
        const opacityBorder = this.hexToRgba(color, 0.5);
        return `border: 1px solid ${opacityBorder}; 
                background-color: ${opacityBackground}; 
                color: ${color};
                display: inline-block;
                padding: 0px 7px;
                width: 'fit-content';
                border-radius: 2px;
                font-size: 12px;`;
    },
    hexToRgba(hex, alpha) {
      let r = parseInt(hex.substring(1, 3), 16);
      let g = parseInt(hex.substring(3, 5), 16);
      let b = parseInt(hex.substring(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },

};
</script>
